export const DOCS_LINK = "https://docs.snap.com/camera-kit/quick-start/integrate-sdk/integrate-sdk-web/quick-start";
